import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { RefreshTokenResData } from "./RefreshTokenResData";

const ENDPOINT = "/auth/refreshtoken";

export class RefreshTokenCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: RefreshTokenReqData;

    constructor(payload: RefreshTokenReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<RefreshTokenResData> {
        var res = await this.executeCommand(this.payload);
        return new RefreshTokenResData(res);
    }
}

export class RefreshTokenReqData {
    refreshToken: string;

    constructor(refreshToken: string) {
        this.refreshToken = refreshToken;
    }
}
